import React, { Component } from "react";
import ContentLoader from "react-content-loader";

export default class ProductDetailCardLoading extends Component {
    render() {
        return (
            <div className="loading">
                <ContentLoader width="100%" height="390">
                    <rect width="70%" height="40" x="15%" y="0" />

                    <rect width="90%" height="20" x="5%" y="60" />
                    <rect width="100%" height="20" x="0" y="90" />

                    <rect width="100%" height="40" x="0" y="130" />

                    <rect width="100%" height="15" x="0" y="190" />
                    <rect width="90%" height="15" x="5%" y="210" />

                    <rect width="100%" height="20" x="0" y="250" />
                    <rect width="100%" height="20" x="0" y="280" />
                    <rect width="100%" height="20" x="0" y="310" />
                    <rect width="100%" height="20" x="0" y="340" />
                    <rect width="100%" height="20" x="0" y="370" />
                </ContentLoader>
            </div>
        );
    }
}
